import NewLogo from '@bb/public/bny-header-logo_sized.png';
import Image from 'next/image';

export function Branding() {
  return (
    <div className="flex items-center border-r-gray-400">
      <Image
        className="block md:hidden"
        src={NewLogo}
        alt="logo"
        width={120}
        height={60}
        priority
      />
      <Image
        className="hidden md:block"
        src={NewLogo}
        alt="logo"
        width={140}
        height={70}
        priority
      />
    </div>
  );
}
